export const AppConstants = {
  TIMEOUTS: {
    DEFAULT: 10000, // 10 seconds
    LONG: 30000, // 30 seconds
    DEBOUNCE_SHORT: 300,
    DEBOUNCE_LONG: 800,
  },
  LIMITS: {
    // Slightly larger target size so images stay crisp
    // on modern high-DPI mobile screens while still
    // being much smaller than raw camera photos.
    MAX_IMAGE_WIDTH: 1600,
    MAX_IMAGE_HEIGHT: 1600,
    MAX_FILE_SIZE_MB: 5,
  },
  HTTP_STATUS: {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
  },
  DATE_FORMATS: {
    DEFAULT: "en-IN",
  },
  DEFAULT_USER_PREFERENCES: {
    preferenceId: "",
    searchRadius: 5,
    ninefindsRadius: 5,
    defaultRadius: true,
    isHyperLocalEnabled: false,
    hyperLocalDistance: 100, // Reasonable default
    searchSortBy: "RECENT",
    userLocation: undefined, // Explicitly undefined to start
  },
  /** Fallback coordinates used when no user location is available at all. */
  DEFAULT_LOCATION: {
    userLatitude: 12.956923999999999,
    userLongitude: 77.701127,
    userLocationDisplayName: "Marathahalli — Marathahalli, Bengaluru, Karnataka 560037, India",
  },
};

/** Welcome kit fee (₹), taken out of a setup's onboarding fee before
 *  commissions are worked out: commission % = amount / (onboardingFee − this).
 *  Change here if the kit price changes. */
export const WELCOME_KIT_FEE = 600;

/** Single source of truth for curator rate percentages:
 *  5 is fixed (5%), 2 is variable (2%). All decimals and ratios are derived from these. */
export const CURATOR_FIXED_PERCENT = 5;
export const CURATOR_VARIABLE_PERCENT = 2;
export const CURATOR_TOTAL_PERCENT = CURATOR_FIXED_PERCENT + CURATOR_VARIABLE_PERCENT;

/** Derived decimals and shares */
export const CURATOR_FIXED_RATE_DECIMAL = CURATOR_FIXED_PERCENT / 100;
export const CURATOR_VARIABLE_RATE_DECIMAL = CURATOR_VARIABLE_PERCENT / 100;
export const CURATOR_FIXED_SHARE_OF_FEE = CURATOR_FIXED_PERCENT / CURATOR_TOTAL_PERCENT;

/** Everything paid on or before this day (IST, YYYY-MM-DD) is already settled
 *  with the team. The Earnings tab marks the line with a divider and leaves
 *  those setups out of every calculation (pending figures). Move it forward
 *  after each settlement. */
export const SETTLED_UNTIL = "2026-10-10";

/** Curators are settled on their own schedule — same meaning as SETTLED_UNTIL,
 *  but for curator earning rows only. Captain and lead rows keep SETTLED_UNTIL. */
export const CURATOR_SETTLED_UNTIL = "2026-10-14";

/** Daily target per captain on the admin Onboarding Calendar's Daily Target
 *  board: a captain "hits target" for a day once this many setups entered the
 *  calendar's selected status that day. Hard-coded for now. */
export const DAILY_TARGET_PER_CAPTAIN = 2;

/** Weekly target per captain (Mon–Sun) on the same board, counted on the
 *  `approved` status. Shown as a gift box (not a target line): hitting it
 *  unlocks the gift. */
export const WEEKLY_TARGET_PER_CAPTAIN = 7;

/** The business day the calendar/targets bucket by — NineFinds operates in
 *  India, so an admin's device timezone must not change the counts. */
export const BUSINESS_TIME_ZONE = "Asia/Kolkata";

/** Daily target per curator: setups claimed per day. */
export const DAILY_TARGET_PER_CURATOR = 2;

/** Weekly target per curator (Mon–Sun): setups completed (QA passed). Shown
 *  as a gift box, like the captains' weekly target. */
export const WEEKLY_TARGET_PER_CURATOR = 5;

/** Lead-pays-their-team settlement is shelved: Nine (admin) pays everyone and
 *  the backend rejects lead payouts. Hides the lead's Settle button and skips
 *  the team-requests fetch. Turn back on only together with the backend's
 *  settlement.onboarding.lead-payer-enabled.
 *  Owner: Sai. Decide by the next settlement-policy review whether lead payouts
 *  return; if not, delete SettleCaptainModal, fetchTeamRequests/settleCaptain/
 *  recordSettlement and their OnboardingDb cases together with this flag. */
export const LEAD_SETTLEMENT_ENABLED = false;
